import React from 'react';
import { Button } from './ui/button';

const BottomCTA = () => {
  const scrollToBooking = () => {
    const element = document.getElementById('booking');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="bg-[#e8ff47] py-20 md:py-32">
      <div className="max-w-[87.5rem] mx-auto px-5 md:px-10 text-center">
        <h2 className="font-['Bebas_Neue'] text-[#0d0d0d] text-5xl md:text-8xl leading-[0.85] tracking-wide mb-6">
          READY TO SHOW
          <br />
          YOUR RESULTS?
        </h2>
        <p className="font-['DM_Sans'] text-[#302f2c] text-lg md:text-xl font-medium mb-10 max-w-2xl mx-auto">
          Book your shoot today. Your transformation deserves to be seen.
        </p>
        <Button 
          onClick={scrollToBooking}
          className="bg-[#0d0d0d] text-[#e8ff47] hover:bg-[#302f2c] hover:scale-105 rounded-full px-10 py-6 font-['DM_Sans'] font-semibold text-base uppercase tracking-tight transition-all"
        >
          Book Your Shoot
        </Button>
      </div>
    </section>
  );
};

export default BottomCTA;
